export default "__VITE_ASSET__CJrYJJE0__"